"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPromoBannerBackgroundStyle = void 0;
var getPromoBannerBackgroundStyle = function (config, isMobile) {
    var _a, _b;
    var backgroundImage = isMobile
        ? (config === null || config === void 0 ? void 0 : config.backgroundImageMobile) || (config === null || config === void 0 ? void 0 : config.backgroundImage)
        : config === null || config === void 0 ? void 0 : config.backgroundImage;
    if (!backgroundImage)
        return undefined;
    var aspectRatio = isMobile
        ? (_a = config === null || config === void 0 ? void 0 : config.aspectRatioMobile) !== null && _a !== void 0 ? _a : config === null || config === void 0 ? void 0 : config.aspectRatio
        : config === null || config === void 0 ? void 0 : config.aspectRatio;
    var maxHeightValue = isMobile
        ? (_b = config === null || config === void 0 ? void 0 : config.maxHeightMobile) !== null && _b !== void 0 ? _b : config === null || config === void 0 ? void 0 : config.maxHeight
        : config === null || config === void 0 ? void 0 : config.maxHeight;
    var maxHeight = typeof maxHeightValue === 'number' ? "".concat(maxHeightValue, "px") : maxHeightValue;
    var resolved = backgroundImage.includes('url(')
        ? backgroundImage
        : "url(".concat(backgroundImage, ")");
    var hasSizing = Boolean(aspectRatio || maxHeight);
    return {
        backgroundImage: resolved,
        aspectRatio: aspectRatio,
        maxHeight: maxHeight,
        height: hasSizing ? 'auto' : undefined,
        minHeight: hasSizing ? 0 : undefined,
        width: hasSizing ? 'auto' : undefined,
        backgroundSize: hasSizing ? 'contain' : undefined,
    };
};
exports.getPromoBannerBackgroundStyle = getPromoBannerBackgroundStyle;
